import { IGetQuickVideosParams } from './useGetQuickVideos';

export const BASE_KEY = 'QUICK_VIDEOS';

export const quickVideoKeys = {
  all: () => [BASE_KEY] as const,
  list: (params: IGetQuickVideosParams) => [BASE_KEY, params] as const,
  single: (quickVideoId: number) => [BASE_KEY, quickVideoId] as const,
  configuration: () => ['CONFIGURATION'] as const,
};
